/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import * as _ from 'lodash';

import {TARGETING_IMPORTS} from '../targeting-imports';

@Component({
  imports: TARGETING_IMPORTS,
  selector: 'adn-targeting-url-summary',
  template: `
    <div>
      <strong *ngIf="not">NOT </strong>
      <span>{{urls}}</span>
      <div *ngIf="restricted && isLimited"><a class="show-hide-link" (click)="liftRestriction()"><span class="fa fa-chevron-down"></span>Show all</a></div>
    </div>
  `
})
export class UrlSummaryComponent implements OnChanges {
  @Input() targets: any;

  urls = '';
  not = false;
  restricted = true;
  isLimited = false;
  private data: string[] = [];
  private readonly quantity = 10;

  ngOnChanges(): void {
    const target = this.targets || {};
    this.data = _.cloneDeep(target.urls) || [];
    this.not = target.negated;
    this.restricted = true;
    this.updateDisplay();
  }

  liftRestriction(): void {
    this.restricted = false;
    this.updateDisplay();
  }

  private updateDisplay(): void {
    this.urls = this.restricted ? this.data.slice(0, this.quantity).join(', ') : this.data.join(', ');
    this.isLimited = this.data.length > this.quantity;
  }
}
